module.exports = __webpack_public_path__ + "static/img/icon2-10.35ea826f.png";